import React, { useState } from "react";
import axios from "axios";
import DialogYesNo from "../DialogYesNo";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons'

const PrzelgadLista = props => {

    const { glosowanieKarty, activeCard, setActiveCard, glosowanieRefresh } = props;

    const handleKarta = e => setActiveCard( glosowanieKarty?.find( g => g?.id == e.currentTarget.id) );

    const handleClick =  (e, id) => {
        e.stopPropagation();
        setActiveCard(null);
        setTrashId(id);
        setOpen(true);  
    }

    const [open, setOpen] = useState(false);
    const [trashId, setTrashId] = useState(0);

    async function usunKarte(id) {
        try {
          const response = await axios.post('/api/glosowanie-karty/usun', { id: id });
          if (response.data.success === true)  {
            glosowanieRefresh();
          }

          console.log('Response from backend:', response.data);
        } catch (error) {
          console.error('Error sending ID to backend:', error);
        }
    }

    const lista = glosowanieKarty?.map( (karta, i) => {

        return (
            <div
                className="karta ramka ramka-border-shadow ramka-wnetrze-ramki pointer"
                style={ karta.id == activeCard?.id ? {backgroundColor: "var(--podswietlenie)"} : {}}
                id={karta.id}
                onClick={handleKarta}
                key={i}
            >
                <p className="numer">{karta.numer}</p>
                <FontAwesomeIcon 
                    icon={faTrash} 
                    onClick={(e)=>handleClick(e, karta.id)}
                />
            </div>
        )
    })

    const brakKart = (
        <div 
            className="ramka ramka-border-shadow ramka-wnetrze-ramki"
        >
            Brak kart do głosowania w tej Wspólnocie
        </div>
    )

    return (
        <div
            className="przegladListaSzczegoly"
        >
            { lista?.length > 0 ? lista : brakKart }
            <DialogYesNo 
                open={open}
                setOpen={setOpen}
                message={`Czy na pewno chcesz usunąć tę kartę?`}
                f={usunKarte}
                id={trashId}
            />
        </div>
    )
}

export default PrzelgadLista;